import { render } from "./ModalPreview.vue?vue&type=template&id=10e7b876"
import script from "./ModalPreview.vue?vue&type=script&lang=js"
export * from "./ModalPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__